module.exports = __webpack_public_path__ + "static/media/ios-flame.254d0694.svg";